// extracted by mini-css-extract-plugin
export default {"Container":"SplashScreen_Container__cgJaw","Inner":"SplashScreen_Inner__Yw7Pa","Hide":"SplashScreen_Hide__6H-Ai"};